import React, { Component } from 'react'
import ReactPagination from "react-js-pagination"
import "./pagination.scss"
import Select from "react-select";
import Icon from "../icon/icon.component.jsx";
import { FormattedMessage } from "react-intl";

class Pagination extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            showPageSize: this.props.showPageSize || false,
            activePage: this.props.activePage || 1,
            pageSize: this.props.pageSize || 10,
            pageSizeMax: this.props.pageSizeMax || 50,
            totalItemsCount: this.props.totalItemsCount || 0,
            className: this.props.className || '',
        }
        this.onChange = this.props.onChange || function () { }
        this.onPageSizeChange = this.props.onPageSizeChange || function () { }
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            activePage: nextProps.activePage || 1,
            pageSize: nextProps.pageSize || 10,
            totalItemsCount: nextProps.totalItemsCount || 0,
            className: nextProps.className || '',
        })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        })
        this.onChange(pageNumber)
    }

    handlePageSizeChange(size) {
        return function (e) {
            e.preventDefault()
            this.setState({
                pageSize: size
            })
            this.onPageSizeChange(size)
        }.bind(this)

    }

    render() {
        return <div className={'row ui-has-modules py-1 d-flex align-items-center ' + this.state.className}>
            <div className="ui-module mb-0 p-0">
                <ReactPagination
                    hideDisabled
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.state.pageSize}
                    totalItemsCount={this.state.totalItemsCount}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                    innerClass="pagination mb-0 pagination-text"
                    activeClass="active"
                    linkClass="page-link border-0"
                    itemClass="page-item"
                    prevPageText={'<'}
                    firstPageText={'l<'}
                    lastPageText={'>l'}
                    nextPageText={'>'}
                />
            </div>
            {this.state.showPageSize && this.state.totalItemsCount > 0 ? <div className="ml-2" role="group">
                <button id="btnGroupDrop1" type="button" className="btn btn-link text-primary btn-sm" data-toggle="dropdown">
                    <FormattedMessage
                        id="common.pagination.per_page_label"
                        defaultMessage="{number} per page"
                        values={{
                            number: this.state.pageSize
                        }}
                    />
                    <Icon value={'caret-down'} className={'ml-1'} />
                </button>
                <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a className="dropdown-item" href="#" onClick={this.handlePageSizeChange(5)}>
                        <FormattedMessage
                            id="common.pagination.per_page_label"
                            defaultMessage="{number} per page"
                            values={{
                                number: 5
                            }}
                        />
                    </a>
                    <a className="dropdown-item" href="#" onClick={this.handlePageSizeChange(10)}>
                        <FormattedMessage
                            id="common.pagination.per_page_label"
                            defaultMessage="{number} per page"
                            values={{
                                number: 10
                            }}
                        />
                    </a>
                    {this.state.pageSizeMax >= 25 ? <a className="dropdown-item" href="#" onClick={this.handlePageSizeChange(25)}>
                        <FormattedMessage
                            id="common.pagination.per_page_label"
                            defaultMessage="{number} per page"
                            values={{
                                number: 25
                            }}
                        />
                    </a> : ''}
                    {this.state.pageSizeMax >= 50 ? <a className="dropdown-item" href="#" onClick={this.handlePageSizeChange(50)}>
                        <FormattedMessage
                            id="common.pagination.per_page_label"
                            defaultMessage="{number} per page"
                            values={{
                                number: 50
                            }}
                        />
                    </a> : ''}
                </div>
            </div> : ''}
            {this.props.children}
        </div>
    }
}

export default Pagination





// WEBPACK FOOTER //
// ./src/common/listing/pagination.component.jsx